import { FormikSwitch, FormikTextField } from "../../../../../shared/components/forms/Formik"
import { StandardMainPanel } from "../../../../../shared/components/forms/StandardMainPanel"
import { StandardSidePanel } from "../../../../../shared/components/forms/StandardSidePanel"
import { StandardForm } from "../../../../../shared/components/forms/StandardForm"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { SalesAccountBase } from "../salesAccountsTypes"

export function CreateUpdateSalesAccountFormContent() {
    return (
        <>
            <StandardForm>
                <StandardMainPanel>
                    <LocalizedStrict
                        id="sales-accounts-form-public-name-label"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikTextField<SalesAccountBase>
                            name="name"
                            label="Name *"
                            placeholder="Enter a name for the sales account"
                            fullWidth
                        />
                    </LocalizedStrict>
                    <LocalizedStrict id="sales-accounts-form-number-label" attrs={{ label: true, placeholder: true }}>
                        <FormikTextField<SalesAccountBase>
                            name="number"
                            label="Number *"
                            placeholder="Enter account number from ERP system"
                            fullWidth
                        />
                    </LocalizedStrict>
                </StandardMainPanel>

                <LocalizedStrict id="sales-accounts-form-general-panel" attrs={{ title: true }}>
                    <StandardSidePanel title="General" variant="collapsible">
                        <LocalizedStrict id="sales-accounts-form-active-switch">
                            <FormikSwitch<SalesAccountBase> name="isActive">Active</FormikSwitch>
                        </LocalizedStrict>
                    </StandardSidePanel>
                </LocalizedStrict>
            </StandardForm>
        </>
    )
}
